import {useFormatCurrency, useFormatNumber} from 'platform/locale';

import {TRANSLATED_LANGUAGES} from '@dms/api/shared';

import {DEFAULT_CURRENCY_CODE} from '../../../constants/DEFAULT_CURRENCY_CODE';
import {useSourcingCurrency} from '../../../hooks/useSourcingCurrency';
import {getSourcingTableColumns} from '../utils/getSourcingTableColumns';

export function useSourcingTableColumns() {
  const currency = useSourcingCurrency();

  const formatNumber = useFormatNumber();
  const formatCurrency = useFormatCurrency();

  return getSourcingTableColumns({
    currency: currency?.code ?? DEFAULT_CURRENCY_CODE,
    formatNumber,
    formatCurrency,
    locale: TRANSLATED_LANGUAGES.czech,
  });
}
